export default __webpack_public_path__ + "static/media/icon-addround.9b7047db.svg";